import ChevronUpIcon from '@heroicons/react/24/solid/ChevronUpIcon';
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
} from '@mui/material';
import { useState } from 'react';

import { CustomMenuItem } from '.';
import { NestedMenuItem } from './useNestedMenu';

export type SideNavMultiLevelProps = {
  item: NestedMenuItem;
};

const SideNavMultiLevel: React.FC<SideNavMultiLevelProps> = ({ item }) => {
  const { items: children } = item;
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(prev => !prev);
  };

  if (!children || children.length === 0) {
    return null;
  }

  return (
    <>
      <ListItemButton
        onClick={handleClick}
        sx={{
          paddingLeft: `${
            item?.level && item.level > 2 ? item.level * 12 : 0
          }px`,
          color: 'neutral.400',
        }}
        className="sidenav__item-button"
      >
        <ListItemIcon sx={{ minWidth: '32px' }}>{item.icon}</ListItemIcon>
        <ListItemText primary={item.title} />

          <SvgIcon fontSize="small" 
            sx={{ 
              color: 'neutral.400',
              transition: "transform .5s ease",
              transform: [open?"":"rotate(90deg);"],
            }}>
            <ChevronUpIcon />
          </SvgIcon>
        {/* {open ? (
        ) : (
          <SvgIcon fontSize="small" sx={{ color: 'neutral.400' }}>
            <ChevronRightIcon />
          </SvgIcon>
        )} */}
      </ListItemButton>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children.map((child: NestedMenuItem, key: number) => (
            <CustomMenuItem key={key} item={child} />
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default SideNavMultiLevel;
